import { useClient, useMutation } from 'Data/Api.js'
import {
  useNotifications,
  notifyError,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useDataValue } from 'Simple/Data.js'
import mutation_send_medical_form from './mutation-send-medical-form.graphql.js'
import query from './query-appointments.graphql.js'
import mutation_send_appointment_reminder from './mutation-send-appointment-reminder.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let client = useClient()
  let patient = useDataValue({
    viewPath: props.viewPath,
    context: 'profile_patient',
  })

  let [, executeSendMedicalFormMutation] = useMutation(
    mutation_send_medical_form
  )

  let [, executeSendAppointmentReminder] = useMutation(
    mutation_send_appointment_reminder
  )

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'MEDICAL_FORM': {
        let mutationSendMedicalFormResponse =
          await executeSendMedicalFormMutation({
            patient_id: patient._id,
            contact_method_association_id: args.phone.id,
          })

        if (mutationSendMedicalFormResponse.error) {
          notify(
            notifyError(
              mutationSendMedicalFormResponse.error.graphQLErrors?.[0]
                ?.message || 'Something went wrong. Please, try again.'
            )
          )
          return
        }

        notify(notifySuccess('Medical Form Sent!'))
        break
      }
      case 'SEND_NEXT_APPOINTMENT_REMINDER': {
        let response = await client
          .query(
            query,
            { patient_id: patient._id },
            { requestPolicy: 'network-only' }
          )
          .toPromise()

        let [booking] =
          response.data?.appointments_upcoming_appointment_bookings_by_patient?.filter(
            item => item.state === 'SCHEDULED'
          ) || []

        if (!booking?.id) {
          notify(
            notifyError(
              'No reminder was sent as no upcoming appointments were found.'
            )
          )
          return false
        }

        let mutationResponse = await executeSendAppointmentReminder({
          appointment_booking_id: booking.id,
          communication_preference_id: args.phone.communication_preferences.id,
        })

        if (mutationResponse.error) {
          notify(notifyError('Something went wrong. Please, try again.'))
          return
        }

        notify(notifySuccess('Last appointment booking reminder sent.'))

        break
      }
      default: {
      }
    }
  }
}
